export default {
  menu: {
    retail_client_management: "零售商管理",
    template_list: "模板列表",
    picture_library: "图片库",
    open_api_management: "开放API管理",
    dashboard: "看板",
    system_setting: "系统设置",
    authorization_level: "权限组",
    approval_flowchart: "审批流程图",
    product_information: "产品信息",
    retail_main_data: "零售",
    outlet: "门店",
    product: "产品",
    user_management: "用户管理",
    user: "用户管理",
    device_management: "设备",
    gateway: "网关",
    screens: "价签",
    price_management: "价格管理",
    price_change_events: "价格变动事件",
    approval: "审批",
    approval_list: "审批列表",
    approval_log: "审批日志",
    system_records: "系统日志",
    synchronized_logs: "同步日志",
    view_company: "查看公司",
    about: "关于",
    view_profile: "查看个人资料",
    logout: "登出",
    english: "英语",
    chinese: "中文",
    indonesian: "印度尼西亚语",
    thai: "泰语",
    armenian: "亚美尼亚语",
    russian: "俄语",
    language: "语言",
    arabic: "阿拉伯语",
    back_to_login: "返回登录",
    enter: "输入",
    no_options_found: "没有数据",
    online: "在线",
    offline: "离线",
    search_site: "站内搜索",
    hide_secretkey: "隐藏密钥",
    show_secretkey: "显示密钥 ",
  },
};
